import React from "react";
import { SITE } from "../data/content";

export default function Footer() {
  return (
    <footer className="bg-[#1E2A4F] text-[#F9F6F0]/70" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16 py-14">
        <div className="grid sm:grid-cols-2 gap-8 items-end">
          <div>
            <p className="font-display text-3xl text-[#F9F6F0]">{SITE.name}</p>
            <p className="text-xs tracking-[0.22em] uppercase mt-2">{SITE.tagline}</p>
          </div>
          <div className="sm:text-right text-sm">
            <p>{SITE.location}</p>
            <p className="mt-1">
              <a href={`mailto:${SITE.email}`} className="ink-link">
                {SITE.email}
              </a>
            </p>
          </div>
        </div>
        <div className="mt-10 pt-6 border-t border-[#F9F6F0]/15 text-xs flex flex-wrap items-center justify-between gap-3">
          <span>© {new Date().getFullYear()} Divya Ramachandran. All stories her own.</span>
          <span className="italic font-display text-[#E76F51]">Made with paper, ink, and patience.</span>
        </div>
      </div>
    </footer>
  );
}
